// eslint-disable-next-line
<template>
    <v-app>
        <v-navigation-drawer
                temporary
                v-model="drawer"
                :mini-variant="mini"
                light
                app
                :right="$store.getters.lang === 'ar'"
        >
            <v-toolbar text class="transparent" short>
                <v-list class="pa-0">
                    <v-list-item link>
                        <a href="https://ta3lim-ar.org">
                            <v-list-item-avatar>
                                <img src="./assets/logo-small.png"/>
                            </v-list-item-avatar>
                        </a>
                        <v-list-item-content>
                            <v-list-item-title>تعليم على الطريق</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-toolbar>
            <v-menu>
                <template v-slot:activator="{ on: menu }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn text
                                   v-on="{ ...tooltip, ...menu }"
                            >
                                {{ $t('nav.uiLang') }}
                            </v-btn>
                        </template>
                        <span>{{ $t('tooltip.setLanguage') }}</span>
                    </v-tooltip>
                </template>
                <v-list>
                    <v-list-item
                            v-for="(lang, index) in langs"
                            :key="index"
                            @click="setLanguage(lang.code)"
                    >
                        <v-list-item-title>{{ lang.title }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-list class="pt-0" dense>
                <v-divider></v-divider>
                <v-list-item v-if="$store.getters.isAuthenticated" link @click="logout()">
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('nav.logout') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

        </v-navigation-drawer>
        <v-app-bar app color="#598377" short fixed dark>
            <img
                    height="64"
                    width="64"
                    src="./assets/logo-small.png"
                    @click="toggleDrawer()"
            />
            <v-toolbar-title @click="$router.push({ name: 'home' })" link class="site-name">
                {{ $t('site.title') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-list-item>{{ userName }}</v-list-item>
            </v-toolbar-items>
        </v-app-bar>
        <v-content>
            <v-sheet
                    color="#DFDFDF"
            >
                <v-breadcrumbs
                        v-if="$store.getters.breadCrumbCount > 0"
                        :items="$store.getters.breadCrumbs"
                ></v-breadcrumbs>
                <router-view/>
            </v-sheet>
        </v-content>
    </v-app>
</template>

<script>
// import NavigationBar from '@/components/NavigationBar'
import BottomNav from "./components/BottomNav";
import User from "./lib/mixins/User";
// import {userLogout} from "./funclib";
// import {destroyToken} from "./authentication";
// import router from "./router";

export default {
  name: 'App',
  components: {BottomNav},
  // components: {NavigationBar},
    mixins: [User],
    data () {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      langs: [
        {
          code: 'en',
          title: 'English'
        },
        {
          code: 'ar',
          title: 'عربي',
        }
      ],
      mini: false,
      right: true,
      rightDrawer: false,
      title: 'Vocab',
      showMenu: false,
    }
  },
  methods: {
    toggleDrawer () {
      this.drawer = !this.drawer;
    },
    setLanguage (lang) {
      // eslint-disable-next-line no-console
      // console.log(lang);
      this.$store.commit('setLanguage', lang);
      this.$vuetify.rtl = (lang === 'ar');
      this.setUserLanguage(lang);
      this.drawer = false;
    },
      logout () {
          this.logoutUser();
          this.drawer = false;
          this.$router.push({ name: 'home' });
      }
  },
    computed: {
      userName () {
          if (this.$store.getters.userInfo) {
              if (this.$store.getters.userInfo.firstName) {
                  return this.$store.getters.userInfo.firstName;
              }
              return this.$store.getters.userInfo.username;
          }
          return '';
      }
    },
  mounted () {
    // eslint-disable-next-line no-console
    // console.log('store.lang', this.$store.state.lang);
    if (this.$store.state.lang)
      this.setLanguage(this.$store.state.lang);
  }
}
</script>

<style>
    @import './assets/main.css';
    @import url('https://fonts.googleapis.com/css?family=Cairo&display=swap');
    #app {
      /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      /*text-align: center;*/
      /*color: #2c3e50;*/
      /*margin-top: 60px;*/
    }
    .site-name {
        font-family: Cairo,sans-serif;
        font-weight: bold;
    }
</style>
